import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ContentForm from '../components/Content/ContentForm';
import { useAuth } from '../hooks/useAuth';

const ContentCreatePage: React.FC = () => {
  const { canAccessMenu, loading, isLoggedIn } = useAuth();
  const [searchParams] = useSearchParams();
  const topicAreaIdParam = searchParams.get('topicAreaId');
  const defaultTopicAreaId = topicAreaIdParam ? Number(topicAreaIdParam) : undefined;

  if (loading) {
    return <div>Loading...</div>;
  }

  // 로그인한 사용자(USER 이상)는 기록 등록 가능
  if (!isLoggedIn()) {
    return (
      <div style={{ background: 'var(--surface)', color: 'var(--text-primary)', border: '1px solid var(--border)', borderRadius: 12, padding: 24 }}>
        <h2>접근 권한이 없습니다</h2>
        <p style={{ color: 'var(--text-secondary)' }}>기록 등록은 로그인한 사용자만 가능합니다.</p>
      </div>
    );
  }

  return <ContentForm defaultTopicAreaId={defaultTopicAreaId} />;
};

export default ContentCreatePage;
